import React, { useEffect, useState } from 'react';

import { capitalize, Dialog, Grid } from '@mui/material';

import { InboundTaskItemStatusEnum } from 'commons/enums';
import {
  PRIMARY_BLACK,
  PRIMARY_BLUE,
  PRIMARY_GREEN,
  PRIMARY_RED,
  PRIMARY_YELLOW,
} from 'commons/styles/colors';
import { IInboundTaskItem } from 'commons/types';
import { InboundTaskReceiveBinList } from 'pages/inbound/inbound-summary/components';

import S from '../InboundInvoiceApprovalItemPage.styles';

export const ItemBinDetailsModal: React.FC<{
  item: IInboundTaskItem | null;
  onClose: () => void;
}> = ({ item, onClose }) => {
  const [showDialog, setShowDialog] = useState<boolean>(false);

  useEffect(() => {
    if (!item || item.receive_actual.length === 0) {
      setShowDialog(false);
    } else {
      setShowDialog(true);
    }
  }, [item]);

  const totalReceivedQty =
    item?.receive_actual.reduce(
      (receivedQty, receiveActual) => receivedQty + receiveActual.quantity,
      0,
    ) || 0;
  const qtyColor =
    totalReceivedQty === 0 || totalReceivedQty !== item?.quantity
      ? PRIMARY_YELLOW
      : PRIMARY_GREEN;
  const statusColor =
    item?.status === InboundTaskItemStatusEnum.APPROVED
      ? PRIMARY_BLUE
      : item?.status === InboundTaskItemStatusEnum.REJECTED
      ? PRIMARY_RED
      : PRIMARY_BLACK;

  return (
    <Dialog
      open={!!item && showDialog}
      onClose={onClose}
      PaperProps={{
        sx: { maxWidth: '80vw', width: '80vw', maxHeight: '80vh' },
      }}
    >
      {/* Title */}
      <S.TitleWrapper container>
        <Grid item xs={12}>
          <b>Item Detail</b>
        </Grid>
      </S.TitleWrapper>

      {/* Content Document Information */}
      <S.ItemInformationWrapper container>
        <Grid item xs={12} sm={2}>
          <S.ItemInfoTitle>SKU Code</S.ItemInfoTitle>
          <S.ItemInfoValue>
            <b>{item?.sku_code || '-'}</b>
          </S.ItemInfoValue>
        </Grid>
        <Grid item xs={12} sm={3}>
          <S.ItemInfoTitle>Name</S.ItemInfoTitle>
          <S.ItemInfoValue>
            <b>{item?.name || '-'}</b>
          </S.ItemInfoValue>
        </Grid>
        <Grid item xs={12} sm={3}>
          <S.ItemInfoTitle>UOM</S.ItemInfoTitle>
          <S.ItemInfoValue>
            <b>{item?.uom || '-'}</b>
          </S.ItemInfoValue>
        </Grid>
        <Grid item xs={12} sm={2}>
          <S.ItemInfoTitle>Total QTY</S.ItemInfoTitle>
          <S.ItemInfoValue>
            <b>
              <span style={{ color: qtyColor }}>{totalReceivedQty}</span>/
              {item?.quantity || 0}
            </b>
          </S.ItemInfoValue>
        </Grid>
        <Grid item xs={12} sm={2}>
          <S.ItemInfoTitle>Status</S.ItemInfoTitle>
          <S.ItemInfoValue>
            <b style={{ color: statusColor }}>
              {!item?.status ||
              item.status === InboundTaskItemStatusEnum.RECEIVED
                ? '-'
                : capitalize(item.status)}
            </b>
          </S.ItemInfoValue>
        </Grid>
      </S.ItemInformationWrapper>

      {/* Item Bin List Table */}
      <div style={{ padding: '0 16px 8px 16px' }}>
        <InboundTaskReceiveBinList receiveActual={item?.receive_actual || []} />
      </div>
    </Dialog>
  );
};
